import React from 'react'
import AvailabilityItemView from './AvailabilityItemView'
import AvailabilityItemEdit from './AvailabilityItemEdit'

const AvailabilityItem = ({ item, isEditing, onEdit, onSave, onCancel, onDelete, isSaving, timezone }) => {
  return (
    <div
      style={{
        border: '1px solid #d9d9d9',
        borderRadius: 4,
        padding: 16,
        backgroundColor: isEditing ? '#fafafa' : 'white',
      }}
    >
      {isEditing ? (
        <AvailabilityItemEdit
          item={item}
          onSave={onSave}
          onCancel={onCancel}
          onDelete={onDelete}
          isSaving={isSaving}
          timezone={timezone}
        />
      ) : (
        <AvailabilityItemView
          item={item}
          onEdit={onEdit}
          onDelete={onDelete}
          isSaving={isSaving}
          timezone={timezone}
        />
      )}
    </div>
  )
}

export default AvailabilityItem
